import { useNavigate } from 'react-router-dom';

function AdminMenu ()
{
    const navigate = useNavigate ();

    return <>
                <h1>Administration</h1>
                <div className="flex flex-row gap-4">
                    <button onClick={ () => navigate ( "funds" ) }>Funds</button>
                    <button onClick={ () => navigate ( "emails/add" ) }>Add Participant Emails</button>
                    <button onClick={ () => navigate ( "emails/check" ) }>Check Participant Email</button>
                </div>
            </>
}

export default AdminMenu;